const addItemEvent = new CustomEvent("refresh", {
  detail: {},
  bubbles: true,
  cancelable: true,
  composed: false,
});

document.addEventListener("DOMContentLoaded", () => {
  const close = document.getElementById("cart-close");
  const drawer = document.getElementById("cart-drawer");
  const inner = document.getElementById("cart-drawer-inner");
  const items = document.getElementById("cart-drawer-items");
  const cartClear = document.getElementById("cart-clear");
  const productCardsWithAddToCart = document.querySelectorAll(
    ".product-card.add-to-cart"
  );

  const productForm = document.querySelector('form[action="/cart/add"]');

  productCardsWithAddToCart?.forEach((productCard) => {
    productCard.addEventListener("click", function (e) {
      if (!e.target.closest("button")) return;
      e.preventDefault();
      let linkElement = productCard;
      if (e.target === productCard) {
        linkElement = e.target.closest("a");
      }

      const { quantity, productId, variantId } = linkElement.dataset;

      addToCart({ quantity, productId, variantId });
    });
  });

  const addToCart = async ({ quantity, productId, variantId }) => {
    let formData = {
      items: [
        {
          quantity,
          id: variantId,
        },
      ],
    };

    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => response.json());

    loadCartItems();
    toggleCart();
  };

  productForm?.addEventListener("submit", async (e) => {
    e.preventDefault();
    const formData = new FormData(productForm);

    await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    }).then((response) => response.json());

    toggleCart();
    document.querySelector("#cart-drawer").dispatchEvent(addItemEvent);
  });

  const loadCartItems = async () => {
    // drawer.classList.add('loading');
    try {
      const cart = await fetch("/sections?section_id=cart-drawer")
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = [
            "#cart-drawer-items",
            "#cart-drawer-total",
            "#cart-drawer-count"
          ];

          const count = html.querySelector("#cart-drawer-count").textContent;

          if (parseInt(count) > 0) {
            document.querySelector("#cart-item-count").classList.remove("hidden");
          }
          else {
            document.querySelector("#cart-item-count").classList.add("hidden");
          }

          document
            .querySelector("#cart-indicator")
            .setAttribute("data-cart-count", count);

          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        });
    } catch (e) {
      console.error(e);
    }

    // drawer.classList.remove('loading');
  };

  const toggleCart = () => {
    if (drawer.classList.contains("open")) {
      if (window.location.pathname === "/cart") {
        window.location = "/";
      }

      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden");
    }

    drawer.classList.toggle("open");

    //loadCartItems();
  };

  const incrementItem = async (id, quantity) => {
    const item = await fetch(`/cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quantity, id }),
    })
      .then((response) => response.json())
      .then((data) => data);
    
    loadCartItems();
  };

  const decrementItem = async (id, quantity, line) => {
    const newCart = await fetch(`/cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quantity, id }),
    })
      .then((response) => response.json())
      .then((data) => data);

    loadCartItems();
  };

  const clearItems = async () => {
    const items = await fetch("/cart/clear.js")
      .then((response) => response.json())
      .then((data) => data);
    loadCartItems();
  };

  close?.addEventListener("click", () => {
    toggleCart();
  });

  //toggleCart();

  cartClear?.addEventListener("click", () => {
    clearItems();
  });

  inner.addEventListener("click", (event) => {
    if (event.target === inner) {
      toggleCart();
    }
    if (event.target.classList.contains("decrease-quantity")) {
      const input = document.getElementById(
        `quantity-${event.target.dataset.target}`
      );
      const quantity = parseInt(input.value);
      const line = event.target.dataset.line;
      decrementItem(event.target.dataset.target, quantity - 1, line);
    }
    if (event.target.classList.contains("increase-quantity")) {
      const input = document.getElementById(
        `quantity-${event.target.dataset.target}`
      );
      const quantity = parseInt(input.value);
      const line = event.target.dataset.line;
      incrementItem(event.target.dataset.target, quantity + 1, line);
    }
  });

  drawer.addEventListener("refresh", (event) => {
    loadCartItems();
  });
});
